import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { Formik, Form, FieldArray, Field } from "formik";
import { useEffect, useRef, useState } from "react"
import { getClassName } from "../../../utils";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { useNavigate } from "react-router-dom";
import { getToneForm } from "../../../services/autofillService";
import { Step } from "../../../components/Step/Step";
import { questions, videos } from "../../../content/personality/tone";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import Countdown from "react-countdown";
import { submitTone } from "../../../services/answersService";
import { StepVideo } from "../../../components/Step/StepVideo";

export const PersonalityTone = () => {
    const [dateNow, setDateNow] = useState(Date.now());
    const dispatch = useDispatch();
    const timerRef = useRef(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [initialValues, setInitialValues] = useState({
        allToneAttributes: [
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            }
        ],
        fiveToneAttributes: [
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            }
        ],
        threeToneAttributes: [
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            },
            {
                toneAttribute: '',
            }
        ],
        companiesThatSoundLikeThat: [
            {
                companyThatSoundsLikeThat: '',
            },
            {
                companyThatSoundsLikeThat: '',
            }
        ],
        peopleThatSoundLikeThat: [
            {
                peopleThatSoundLikeThat: ''
            },
            {
                peopleThatSoundLikeThat: ''
            }
        ],
    });
    const [disabled, setDisabled] = useState(false);

    const handleSubmit = values => {
        setIsLoading(true);
        submitTone(values).then(response => {
            setIsLoading(false)
            navigate("/flow/personality/attributes")
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        })
    }

    const countdownRenderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            setDisabled(true);
        }
        if (seconds < 10) {
            return (
                <span className="has-yellow-text">
                    0{minutes} : 0{seconds}
                </span>
            );
        } else {
            return (
                <span className="has-yellow-text">
                    0{minutes} : {seconds}
                </span>
            );
        }
    }

    const handleUpClick = () => {
        setActiveStep(activeStep - 1)
        if (activeStep === 4) {
            dispatch(setProgress(83));
        } else if (activeStep === 3) {
            dispatch(setProgress(80));
        } else if (activeStep === 2) {
            dispatch(setProgress(76));
        } else if (activeStep === 1) {
            dispatch(setProgress(73));
        }
    }

    const handleDownClick = (values) => {
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(76));
        } else if (activeStep === 1) {
            dispatch(setProgress(80));
        } else if (activeStep === 2) {
            dispatch(setProgress(83));
        } else if (activeStep === 3) {
            dispatch(setProgress(86));
        }
    }

    const fiveToneAttributesInformation = values => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">All Tone of Voice Attributes</p>
            <ul>
                {values.allToneAttributes.map((el, index) => (
                    <li className="text-light-grey text-sm" key={index}>
                        {el.toneAttribute}
                    </li>
                ))}
            </ul>
        </div>
    )

    const threeToneAttributesInformation = values => (
        <div className="flex flex-col gap-2 flex-1">
            <p className="text-light-grey text-sm">Five Tone of Voice Attributes</p>
            <ul>
                {values.fiveToneAttributes.map((el, index) => (
                    <li className="text-light-grey text-sm" key={index}>
                        {el.toneAttribute}
                    </li>
                ))}
            </ul>
        </div>
    )

    const handlePlay = () => {
        timerRef.current.pause();
    }

    const handlePause = (touched) => {
        timerRef.current.start();
    }

    useEffect(() => {
        dispatch(setProgress(73))
        getToneForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })
    }, [dispatch]);

    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                    handleChange={() => console.log("a")}
                >
                    {({ values, errors, touched }) => (
                        <>
                            <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                                <section className="flex flex-col items-center justify-center w-full h-full">
                                    <StepVideo 
                                    className={getClassName(0, activeStep)} 
                                    question={questions.allToneAttributes} 
                                    url={videos.allToneAttributesVideo.url}
                                    onPause={() => handlePause(touched)}
                                    onPlay={handlePlay}
                                    >
                                        <Countdown
                                            ref={timerRef}
                                            date={dateNow + 5 * 60 * 1000}
                                            renderer={countdownRenderer}
                                            autoStart={false}
                                        />
                                        <FieldArray name="allToneAttributes">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.allToneAttributes.length > 0 &&
                                                        values.allToneAttributes.map((toneAttribute, index) => (
                                                            <Field
                                                                name={`allToneAttributes.${index}.toneAttribute`}
                                                                placeholder="Adjective"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                                disabled={disabled}
                                                            />
                                                        ))
                                                    }
                                                    <AddMore onClick={() => push({ toneAttribute: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </StepVideo>
                                    <Step
                                        className={getClassName(1, activeStep)}
                                        question={questions.fiveToneAttributes}
                                        url={videos.fiveToneAttributesVideo.url}
                                        information={fiveToneAttributesInformation(values)}
                                    >
                                        <FieldArray name="fiveToneAttributes">
                                            <>
                                                {values.fiveToneAttributes.length > 0 &&
                                                    values.fiveToneAttributes.map((toneAttribute, index) => (
                                                        <Field
                                                            name={`fiveToneAttributes.${index}.toneAttribute`}
                                                            placeholder="Adjective"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                        />
                                                    ))}
                                            </>
                                        </FieldArray>
                                    </Step>
                                    <Step 
                                    className={getClassName(2, activeStep)} 
                                    question={questions.threeToneAttributes} 
                                    url={videos.threeToneAttributesVideo.url}
                                    information={threeToneAttributesInformation(values)}
                                    >
                                        <FieldArray name="threeToneAttributes">
                                            <>
                                                {values.threeToneAttributes.length > 0 &&
                                                    values.threeToneAttributes.map((toneAttribute, index) => (
                                                        <Field
                                                            name={`threeToneAttributes.${index}.toneAttribute`}
                                                            placeholder="Adjective"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                        />
                                                    ))}
                                            </>
                                        </FieldArray>
                                    </Step>
                                    <Step className={getClassName(3, activeStep)} question={questions.companiesThatSoundLikeThat}>
                                        <FieldArray name="companiesThatSoundLikeThat">
                                            <>
                                                {values.companiesThatSoundLikeThat.length > 0 &&
                                                    values.companiesThatSoundLikeThat.map((companyThatSoundsLikeThat, index) => (
                                                        <Field
                                                            name={`companiesThatSoundLikeThat.${index}.companyThatSoundsLikeThat`}
                                                            placeholder="Company"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                        />
                                                    )
                                                    )}
                                            </>
                                        </FieldArray>
                                    </Step>
                                    <Step className={getClassName(4, activeStep)} question={questions.peopleThatSoundLikeThat}>
                                        <FieldArray name="peopleThatSoundLikeThat">
                                            <>
                                                {values.peopleThatSoundLikeThat.length > 0 &&
                                                    values.peopleThatSoundLikeThat.map((peopleThatSoundLikeThat, index) => (
                                                        <Field
                                                            name={`peopleThatSoundLikeThat.${index}.peopleThatSoundLikeThat`}
                                                            placeholder="Brand or Celebrity"
                                                            className="has-border-bottom mt-3"
                                                            key={index}
                                                        />
                                                    ))}
                                            </>
                                        </FieldArray>
                                    </Step>
                                </section>
                                <Buttons link="/flow/personality/look">
                                    <UpButton onClick={() => handleUpClick(values)} disabled={activeStep === 0} />
                                    {(activeStep === 4) ? (
                                        <button type="submit" className="btn yellow-cta">
                                            {isLoading ? <Oval
                                                height={30}
                                                width={50}
                                                color="black"
                                                secondaryColor="black"
                                            /> : (
                                                <span>
                                                    Next
                                                </span>
                                            )}
                                        </button>
                                    ) : (
                                        <DownButton onClick={handleDownClick} disabled={activeStep === 4} />
                                    )}
                                </Buttons>
                            </Form>
                        </>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Personality & Charisma" />
        </>
    )
}